import React, { useEffect, useState } from 'react'
import { useFormik } from 'formik';
import * as Yup from 'yup';
import GeneralService from '../../services/general.service';

const isValidTime = (time) => {
  const [hour, minute] = time.split(':');
  const hourInt = parseInt(hour, 10);
  const minuteInt = parseInt(minute, 10);
  
  const timeValue = hourInt + minuteInt / 60;
  return timeValue >= 10 && timeValue <= 22;
};

const appointmentSchema = Yup.object({
    service: Yup.string().required('Required'),
    doctor: Yup.string().required('Required'),
    name: Yup.string().required('Required'),
    phone: Yup.string()
      .matches(/^[0-9+\-\s()]*$/, 'Invalid phone number format')
      .test('phone-length', 'Phone number must be exactly 11 digits', (value) => {
        if (!value) return false;
        // Remove all non-digit characters to count only digits
        const digitsOnly = value.replace(/\D/g, '');
        return digitsOnly.length === 11;
      })
      .required('Required'),
    date: Yup.date().required('Required'),
    time: Yup.string()
    .required('Required')
    .test('is-valid-time', 'Time must be between 10:00 AM and 10:00 PM', (value) => {
      return isValidTime(value);
    })
  });

export default function Appointment() {
    const [notification, setNotification] = useState({ show: false, message: '', type: '' });

    const showNotification = (message, type = 'success') => {
        setNotification({ show: true, message, type });
        setTimeout(() => {
            setNotification({ show: false, message: '', type: '' });
        }, 4000);
    };

    const {
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        isSubmitting,
        resetForm,
      } = useFormik({
        initialValues: {
          service: '',
          doctor: '',
          name: '',
          phone: '',
          date: '',
          time: '',
        },
        validationSchema: appointmentSchema,
onSubmit: async (values, { setSubmitting }) => {
    try {
        const response = await GeneralService.makeAppointment(values);
        console.log('API Response:', response);
        
        showNotification('Appointment booked successfully!', 'success');
        resetForm();
        scrollToTop();
        
        // Use appointment_id instead of user_id for notification
        try {
            const appointmentId = response.data.appointment_id; // Get appointment_id from response
            await GeneralService.sendNotification(appointmentId, 'appointment');
            console.log('Admin notification sent with appointment ID:', appointmentId);
        } catch (notificationError) {
            console.log('Admin notification failed:', notificationError);
            // Don't fail the appointment booking if notification fails
        }
        
    } catch (error) {
        console.error('Appointment error:', error);
        
        let errorMessage = 'Appointment booking failed. Please try again.';
        
        if (error.response && error.response.data && error.response.data.message) {
            errorMessage = error.response.data.message;
        } else if (error.message) {
            errorMessage = error.message;
        }
        
        showNotification(errorMessage, 'error');
    } finally {
        setSubmitting(false);
    }
},
      });

      const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      };
    
      useEffect(() => {
        scrollToTop(); 
      }, []); 
    
  return (
    <>
    {/* Custom Notification */}
    {notification.show && (
        <div 
            className={`position-fixed top-0 end-0 m-3 alert ${notification.type === 'success' ? 'alert-success' : 'alert-danger'} alert-dismissible fade show`}
            style={{ zIndex: 9999, minWidth: '300px' }}
            role="alert"
        >
            {notification.message}
            <button 
                type="button" 
                className="btn-close" 
                onClick={() => setNotification({ show: false, message: '', type: '' })}
                aria-label="Close"
            ></button>
        </div>
    )}

        {/* <!-- Appointment Start --> */}
        <div id="appointment-form" className="container-fluid bg-primary bg-appointment my-5 wow fadeInUp" data-wow-delay="0.1s">
        <div className="container">
            <div className="row gx-5">
                <div className="col-lg-6 py-5">
                    <div className="py-5">
                        <h2 className="display-5 text-white mb-4">We Are A Certified and Award Winning Drug Addiction Treatment Clinic You Can Trust</h2>
                        <p className="text-white mb-0">Our clinic is recognized for its excellence in providing top-notch treatment and care. With certifications and awards from leading healthcare organizations, we are dedicated to delivering the best possible outcomes for our patients.</p>
                        <p className="text-white mb-0">ہماری کلینک کو بہترین علاج اور دیکھ بھال فراہم کرنے کے حوالے سے اعلیٰ معیار کے ادارے کے طور پر تسلیم کیا جاتا ہے۔ معروف صحت کے اداروں سے سرٹیفکیٹس اور ایوارڈز حاصل کرنے کے بعد، ہم اپنے مریضوں کو بہترین ممکنہ نتائج فراہم کرنے کے لیے پُرعزم ہیں۔</p>
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="appointment-form h-100 d-flex flex-column justify-content-center text-center p-5 wow zoomIn" data-wow-delay="0.6s">
                        <h3 className="display-6 text-white mb-4">Make Appointment</h3>
                        <form onSubmit={handleSubmit}>
      <div className="row g-3">
        <div className="col-12 col-sm-6">
  <label htmlFor="service" className="form-label" style={{color: "#fff"}}>Appointment Service</label>
          <select
            name="service"
            className={`form-select bg-light border-0 ${touched.service && errors.service ? 'is-invalid' : ''}`}
            style={{ height: '55px' }}
            value={values.service}
            onChange={handleChange}
            onBlur={handleBlur}
          >
            <option value="">Select A Service</option>
            <option value="Ice Treatment">Ice Treatment (آئس علاج)</option>
            <option value="Alcohol Treatment">Alcohol Treatment (شراب علاج)</option>
            <option value="Heroin Treatment">Heroin Treatment (ہیروئن علاج)</option>
            <option value="Opium Treatment">Opium Treatment (افیون علاج)</option>
            <option value="Hashish Treatment">Hashish Treatment (چرس علاج)</option>
            <option value="Cocaine Treatment">Cocaine Treatment (کوکین علاج)</option>
            <option value="Sedative Treatment">Sedative Treatment (نشہ و ادویات کا علاج) </option>
          </select>
          {touched.service && errors.service && <div className="invalid-feedback">{errors.service}</div>}
        </div>
        <div className="col-12 col-sm-6">
  <label htmlFor="doctor" className="form-label" style={{color: "#fff"}}>Appointment Doctor</label>
          <select
            name="doctor"
            className={`form-select bg-light border-0 ${touched.doctor && errors.doctor ? 'is-invalid' : ''}`}
            style={{ height: '55px' }}
            value={values.doctor}
            onChange={handleChange}
            onBlur={handleBlur}
          >
            <option value="">Select Doctor</option>
            <option value="Muhammad Zubair Mukhtar">Muhammad Zubair Mukhtar</option>
            <option value="Dr. Haris Burki">Dr. Haris Burki</option>
          </select>
          {touched.doctor && errors.doctor && <div className="invalid-feedback">{errors.doctor}</div>}
        </div>
        <div className="col-12 col-sm-6">
  <label htmlFor="name" className="form-label" style={{color: "#fff"}}>Patient Name</label>
          <input
            type="text"
            name="name"
            className={`form-control bg-light border-0 ${touched.name && errors.name ? 'is-invalid' : ''}`}
            placeholder="Your Name"
            value={values.name}
            onChange={handleChange}
            onBlur={handleBlur}
            style={{ height: '55px' }}
          />
          {touched.name && errors.name && <div className="invalid-feedback">{errors.name}</div>}
        </div>

        
        <div className="col-12 col-sm-6">
  <label htmlFor="phone" className="form-label" style={{color: "#fff"}}>Phone Number</label>
          <input
            type="tel"
            name="phone"
            className={`form-control bg-light border-0 ${touched.phone && errors.phone ? 'is-invalid' : ''}`}
            placeholder="Enter Number (11 digits)"
            value={values.phone}
            onChange={handleChange}
            onBlur={handleBlur}
            style={{ height: '55px' }}
            maxLength="11"
          />
          {touched.phone && errors.phone && <div className="invalid-feedback">{errors.phone}</div>}
        </div>
        <div className="col-12 col-sm-6">
  <label htmlFor="date" className="form-label" style={{color: "#fff"}}>Appointment Date</label>
          <input
            type="date"
            name="date"
            className={`form-control bg-light border-0 ${touched.date && errors.date ? 'is-invalid' : ''}`}
            placeholder="Appointment Date"
            value={values.date}
            onChange={handleChange}
            onBlur={handleBlur}
            style={{ height: '55px' }}
          />
          {touched.date && errors.date && <div className="invalid-feedback">{errors.date}</div>}
        </div>
        <div className="col-12 col-sm-6">
  <label htmlFor="time" className="form-label" style={{color: "#fff"}}>Appointment Time</label>
  <input
    type="time"
    name="time"
    id="time"
    className={`form-control bg-light border-0 ${touched.time && errors.time ? 'is-invalid' : ''}`}
    value={values.time}
    onChange={handleChange}
    onBlur={handleBlur}
    style={{ height: '55px' }}
  />
  {touched.time && errors.time && <div className="invalid-feedback">{errors.time}</div>}
</div>

        <div className="col-12">
          <button className="btn btn-dark w-100 py-3" type="submit" disabled={isSubmitting}>
            {isSubmitting ? 'Submitting...' : 'Make Appointment'}
          </button>
        </div>
      </div>
    </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
    {/* <!-- Appointment End --> */}
    </>

  )
}